<template>
  <!-- Main banner for homepage containing anchor links for Theme and Country -->
  <div id="banner-container">
    <div
      id="banner"
      :style="{ 'background-image': `url(${bannerImage})` }"
      @mouseover="showImageInfo = true"
      @mouseleave="showImageInfo = false"
    >
      <div id="banner-title">Explore</div>
      <!-- Banner text comes from the VO/API -->
      <div id="banner-text" v-html="bannerText"></div>
      <div id="banner-image-info" v-if="showImageInfo">
        <span v-if="imageName.length > 0">{{ imageName }}, </span>
        <span v-if="imageLocation.length > 0">{{ imageLocation }}, </span>
        <span v-if="imageCountry.length > 0">{{ imageCountry }}</span>
      </div>
    </div>
  </div>
</template>

<script>
// Mixin for getting text from VO/API
import homepageTexts from "../mixins/homepageTexts.js";
import language from "../mixins/language.js";
export default {
  name: "BannerComponent",
  mixins: [homepageTexts, language],
  data() {
    return {
      bannerImage: "",
      bannerText: "",
      showImageInfo: false,
      imageName: "",
      imageLocation: "",
      imageCountry: "",
    };
  },
  methods: {
    getBannerImage: function () {
      axios({
        method: "GET",
        url: `${process.env.VUE_APP_API_ENDPOINT}/banners`,
      }).then(
        (result) => {
          this.bannerImage = result.data.path;
          let setInfo = (data, prop) => {
            if (data.length > 0) {
              this[prop] = this.returnValueInLanguage("en", data).value;
            }
          };
          setInfo(result.data.monumentName, "imageName");
          setInfo(result.data.locationName, "imageLocation");
          setInfo(result.data.countryName, "imageCountry");
        },
        (error) => {
          console.error(error);
        }
      );
    },
  },
  mounted() {
    this.getBannerImage();
    this.getTexts("bannerText", "Home-Leitmotif");
  },
};
</script>

<style scoped lang="scss">
#banner-container {
  width: 100%;
}
#banner {
  @include flex-center;
  flex-direction: column;
  position: relative;
  height: 200px;
  width: 100%;
  // background-image: url("../assets/banner.jpg");
  background-position: center;
  background-size: cover;
  box-shadow: inset 0 0 0 500px rgba($dark-grey, 0.3);
  color: white;
  padding: 30px;
}
#banner-title {
  @include headings;
  @include font-size-1;
  color: $white;
  text-shadow: -1px 1px 1px $dark-grey;
  margin-bottom: 20px;
}
#banner-text {
  @include headings;
  @include font-size-3;
  width: 100%;
  color: $white;
  font-weight: normal;
  text-align: center;
  text-shadow: -1px 1px 1px $dark-grey;
}
#banner-image-info {
  position: absolute;
  right: 0;
  bottom: 0;
  font-size: 11px;
  text-shadow: -1px 1px 1px $dark-grey;
}

@media only screen and (max-width: 1199px) {
  #banner-text {
    @include headings;
    @include font-size-4;
    color: $white;
    font-weight: normal;
  }
}

@media only screen and (max-width: 499px) {
  #banner-title {
    @include font-size-2;
  }
  #banner-text {
    @include font-size-5;
  }
}
</style>
